import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, Renderer2, Inject } from "@angular/core";
import { HttpHelpService } from "../service/http-help.service";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { addNewMerchantByAdmin } from '../service/global.service';
import { israelPhoneNumberValidator } from './../../validators/israelPhoneNumberValidator';
import { passwordValidators } from 'src/app/validators/passwordValidators';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'src/app/Auth/service/auth.service';
import { DatePipe } from '@angular/common';
import { start } from 'repl';
import { CompaniesService } from 'src/app/components/alldocuments/alldocuments-companies/companies.service';
import {
	InvoiceSubscriptionsV2Service,
	InvoiceSubscriptionStatus,
	CanIssueDocumentResponse,
} from 'src/app/services/invoice-subscriptions-v2.service';
import { NavService } from 'src/app/shared/services/nav.service';
import { getDefaultReportLanguage } from 'src/app/shared/services/report-language-preference';

/**
 * @description Merchant component for managing merchant data, operations, and reports.
 * Handles displaying merchant information, adding new merchants, managing company associations,
 * and generating various reports like sales reports and customer account statements.
 */
@Component({
	selector: "app-merchant",
	templateUrl: "./merchant.component.html",
	styleUrls: ["./merchant.component.scss"],
	providers: [ConfirmationService, MessageService, DatePipe]
})
export class MerchantComponent implements OnInit, OnDestroy {
	/** @description Current language setting for the application. */
	curentLang: string = "";
	/** @description Layout version (e.g., 'light-only', 'dark-only'). */
	layoutVersion: any;
	/** @description ID of the currently registered user. */
	userRegistId: any = JSON.parse(localStorage.getItem('user_id'));
	/** @description ID of the current merchant. */
	merchantId = JSON.parse(localStorage.getItem('merchant_id'));
	/** @description Type of the current user. */
	user_type = JSON.parse(localStorage.getItem('user_type'));
	/** @description Default company ID for the merchant. */
	companyDefault = JSON.parse(localStorage.getItem('companyDefault'));
	/** @description Company name in Arabic. */
	company_name_ar = localStorage.getItem('company_name_ar');
	/** @description Company name in English. */
	company_name_en = localStorage.getItem('company_name_en');
	/** @description Company name in Hebrew. */
	company_name_he = localStorage.getItem('company_name_he');

	/** @description Form group for adding/editing merchant details. */
	merchantForm: FormGroup;
	/** @description Search term for filtering merchant list. */
	term: any;
	/** @description Current page number for pagination. */
	p: any;
	/** @description Array to store merchant information data. */
	merchantInfoData: any = [];
	/** @description Array to store user data for dropdowns. */
	userData: { user_id: number; user_name: string }[] = []; 
	/** @description Array to store customer data for account statement dropdown. */
	customerAccountStatementUserData: {
		user_id: number;
		customer_display_label: string;
		user_name: string;
	}[] = [];
	/** @description Phone number of the merchant. */
	MerchantPhone: any;
	/** @description Flag to toggle password visibility. */
	public show: boolean = false;
	/** @description Flag to trigger form validation messages. */
	public validate = false;
	/** @description Array to store profile data of the current user/merchant. */
	profileData: any = [];
	/** @description File object for image uploads. */
	public file: any;
	/** @description URL for displaying uploaded image preview. */
	url: any;
	/** @description Array of files for upload (currently unused, consider for multi-file). */
	files: File[] = [];
	/** @description Array to store company data. */
	companyData: any = [];
	/** @description Array of allowed invoice types for the selected company. */
	allowedInvoiceTypes: number[] = [];
	/** @description URL of the selected company's logo. */
	selectedCompanyLogo: string | null = null;
	/** @description Name of the selected company in Arabic. */
	companyNameAr: string | null = null;
	/** @description Name of the selected company in English. */
	companyNameEn: string | null = null;
	/** @description Name of the selected company in Hebrew. */
	companyNameHe: string | null = null;
	/** @description URL of the current image being displayed or uploaded. */
	currentImageUrl: any;
	/** @description ViewChild for ng-template content4 (Reports). */
	@ViewChild('content4', { static: true }) content4!: TemplateRef<any>;
	/** @description ViewChild for ng-template content5 (Customer Account Statement). */
	@ViewChild('content5', { static: true }) content5!: TemplateRef<any>;
	/** @description Selected period value for reports (e.g., 1 for current month). */
	selectedPeriod: number = 1;
	/** @description Start date for report filtering, formatted as string. */
	fromDate: string | null = null;
	/** @description End date for report filtering, formatted as string. */
	toDate: string | null = null;
	/** @description Form group for document related operations. */
	documentForm: FormGroup;
	/** @description Form group for general reports. */
	reportsForm: FormGroup;
	/** @description Form group for customer account statement report. */
	customerAccountStatementForm: FormGroup;
	/** @description Form group for sales report. */
	salesReportForm: FormGroup;
	/** @description ID of the currently selected company. */
	CompanyId: any;
	/** @description The selected company object or ID. */
	selectedCompany: any;
	/** @description Index of the selected company (currently unused). */
	selectedCompanyIndex: any;
	/** @description Current page for paginated company list. */
	currentPage: number = 1;
	/** @description Number of items per page for company list. */
	limit: number = 400;
	/** @description Offset for paginated company list. */
	offset: number = 0;
	/** @description Total number of companies. */
	total: number = 0;
	/** @description Option for selecting all companies in dropdowns. */
	allCompaniesOption = { company_id: this.companyData, company_name_en: 'All Companies', company_name_ar: 'الكل', company_name_he: 'הכל' };
	/** @description Name of the selected company, localized. */
	selectedCompanyName: any;
	/** @description Form group for image upload. */
	uploadImage = new FormGroup({
		file: new FormControl(''),
		id: new FormControl(''),
	});
	/** @description Date range validation error message for modal. */
	modalDateRangeError: string = '';
	/** @description Flag to control visibility of the sales report modal. */
	isSalesReportModalVisible: boolean = false;
	/** @description Flag to control visibility of the customer account statement modal. */
	isCustomerAccountStatementModalVisible: boolean = false;
	/** @description ID of the selected customer for reports. */
	selectedCustomer: number; 
	/** @description Options for the period selection dropdown in reports. */
	periodOptions = [
		{ label: this.translate.instant('merchant-info.common.currentMonth'), value: 1 },
		{ label: this.translate.instant('merchant-info.common.lastMonth'), value: 2 },
		{ label: this.translate.instant('merchant-info.common.lastTwoMonths'), value: 5 },
		{ label: this.translate.instant('merchant-info.common.startOfYear'), value: 3 },
		{ label: this.translate.instant('merchant-info.common.lastYear'), value: 4 }
	];
	/** @description Flag to control visibility of the confirmation dialog for reports. */
	isConfirmDialogVisible: boolean = false;
	/** @description Data for rendering the account statement PDF. */
	accountStatementPdfData: any = null;
	/** @description Flag to indicate if a PDF is currently being prepared. */
	isPreparingPdf: boolean = false;
	/** @description Flag to indicate if the current view is on a mobile device. */
	isMobile: boolean = false;

	/** @description Flag to ensure dialog maximization on mobile happens only once. */
	private maximizedOnce: boolean = false;

	/** Banner: subscription ends within 7 days (merchant-info). */
	showSubscriptionExpiringBanner = false;
	/** Days left for translate interpolation. */
	subscriptionExpiringDaysRemaining: number | null = null;

	private static readonly SUB_EXPIRING_DISMISS_MS = 86400000;
	private static readonly SUB_EXPIRING_MAX_DAYS = 7;

	/**
	 * @constructor
	 * @param {DatePipe} datepipe - Service for formatting dates.
	 * @param {NgxSpinnerService} spinner - Service for showing loading spinners.
	 * @param {TranslateService} translate - Service for internationalization.
	 * @param {HttpHelpService} service - Custom HTTP service for API calls.
	 * @param {Router} router - Angular router service.
	 * @param {NgbModal} modalService - Service for Bootstrap modals.
	 * @param {ChangeDetectorRef} cdRef - Service for manual change detection.
	 * @param {FormBuilder} fb - Service for creating reactive forms.
	 * @param {ConfirmationService} confirmationService - PrimeNG service for confirmation dialogs.
	 * @param {MessageService} messageService - PrimeNG service for messages/toasts.
	 * @param {Renderer2} renderer - Angular renderer for DOM manipulation.
	 * @param {Document} document - Angular's representation of the document.
	 * @param {AuthService} authService - Service for authentication related operations.
	 */
	constructor(
		private datepipe: DatePipe,
		private spinner: NgxSpinnerService,
		public translate: TranslateService,
		private service: HttpHelpService,
		private router: Router,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		private cdRef: ChangeDetectorRef,
		private fb: FormBuilder,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private renderer: Renderer2,
		@Inject(DOCUMENT) private document: Document,
		private authService: AuthService,
		private companiesService: CompaniesService,
		private invoiceSubscriptionsV2: InvoiceSubscriptionsV2Service,
		private navService: NavService
	) {
		this.curentLang = localStorage.getItem('curentLang');
		this.user_type = JSON.parse(localStorage.getItem('user_type'));
		this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));

		this.merchantForm = new FormGroup({
			'phone_number': new FormControl('', [Validators.required, israelPhoneNumberValidator()]),
			'user_name': new FormControl('', [Validators.required, Validators.maxLength(20)]),
			'language': new FormControl(this.curentLang),
			'merchant_name_en': new FormControl('', [Validators.maxLength(80)]),
			'merchant_name_ar': new FormControl('', [Validators.maxLength(80)]),
			'merchant_name_he': new FormControl('', [Validators.required, Validators.maxLength(80)]),
			'merchant_address': new FormControl('', [Validators.required]),
			'id_number': new FormControl('', [Validators.required, Validators.maxLength(20)]),
			'password': new FormControl('', passwordValidators),
			created_by: new FormControl(this.userRegistId),
		});

		this.documentForm = new FormGroup({
			companyId: new FormControl(this.selectedCompany),
			startDate: new FormControl('', Validators.required),
			endDate: new FormControl('', Validators.required),
		});

		this.reportsForm = this.fb.group({
			companyId: [null],
			startDate: [''],
			endDate: [''],
			document_type: [1],
			lang: getDefaultReportLanguage()
		});

		this.customerAccountStatementForm = this.fb.group({
			startDate: [''],
			endDate: [''],
			selectedCustomer: [null, Validators.required], 
			selectedPeriod: [null, Validators.required],
			lang: [getDefaultReportLanguage()]
		});

		this.salesReportForm = this.fb.group({
			startDate: [''],
			endDate: [''],
			companyId: [null, Validators.required], 
			selectedPeriod: [null, Validators.required],
			lang: [getDefaultReportLanguage()]
		});

		
		this.reportsForm.patchValue({
			selectedCustomer: this.userData.length > 0 ? this.userData[0].user_id : null
		});

		
		const currentDate = new Date();
		const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
		const endDate = currentDate;

		this.customerAccountStatementForm.patchValue({
			startDate: this.formatDate(startDate),
			endDate: this.formatDate(endDate),
			selectedPeriod: 1,
		});


		this.salesReportForm.patchValue({
			startDate: startDate,
			endDate: endDate,
			selectedPeriod: 1,
		});
		this.updateIsMobile();
		window.addEventListener('resize', this.updateIsMobile.bind(this));
	};


	/**
	 * @description Angular lifecycle hook called after every check of the component's view.
	 * Used here to maximize the dialog automatically on small screens when it first opens.
	 */
	ngAfterViewChecked(): void {
		if (
			this.isCustomerAccountStatementModalVisible &&
			window.innerWidth < 768 &&
			!this.maximizedOnce
		) {
			this.clickMaximizeButton();
			this.maximizedOnce = true;
		}
		if (
			this.isSalesReportModalVisible &&
			window.innerWidth < 768 &&
			!this.maximizedOnce
		) {
			this.clickMaximizeButton();
			this.maximizedOnce = true;
		}
	}

	/**
	 * @description Programmatically clicks the maximize button of the PrimeNG dialog.
	 * Used for responsive behavior on small screens.
	 * @protected
	 */
	protected clickMaximizeButton() {
		
		const dialogEl = document.querySelector('.p-dialog') as HTMLElement;
		if (dialogEl) {
			const maximizeBtn = dialogEl.querySelector('.p-dialog-header-maximize') as HTMLElement;
			if (maximizeBtn) {
				maximizeBtn.click();
			}
		}
	}

	
	/**
	 * @description Submits the merchant form data to create a new merchant.
	 * Performs validation before submitting.
	 * @param {FormGroup} merchantForm - The merchant form group.
	 */
	submitMerchantForm(merchantForm: FormGroup) {
		
		let customerPhone = this.merchantForm.value.phone_number;
		if (customerPhone.startsWith('0')) {
			customerPhone = customerPhone.substring(1);
		}

		
		if (
			this.merchantForm.value.phone_number === '' ||
			this.merchantForm.value.user_name === '' ||
			this.merchantForm.value.password === '' ||
			this.merchantForm.value.merchant_name_he === '' ||
			this.merchantForm.value.merchant_address === ''
		) {
			Swal.fire({
				icon: 'warning',
				title: this.translate.instant('merchant-info.submitMerchantForm.requiredFields')
			});
			this.validate = !this.validate;
			return;
		} else {
			
			let merchantPhone = this.merchantForm.value.phone_number;
			if (merchantPhone.length < 7) {
				Swal.fire({
					icon: 'error',
					title: this.translate.instant('merchant-info.submitMerchantForm.phoneMinLength')
				});
				return;
			}

			
			const validPrefixes = ['50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
			let validationStartPhoneNumber = customerPhone.substring(0, 2);

			if (!validPrefixes.includes(validationStartPhoneNumber)) {
				Swal.fire({
					icon: 'warning',
					title: this.translate.instant('merchant-info.submitMerchantForm.phonePrefix')
				});
				return;
			}

			
			let customerPhoneFinal = this.merchantForm.value.phone_number;
			if (customerPhoneFinal.startsWith('0')) {
				customerPhoneFinal = customerPhoneFinal.substring(1);
			}

			
			let model = {
				phone_number: '+972' + customerPhoneFinal,
				user_name: merchantForm.value.user_name,
				language: this.curentLang,
				merchant_name_en: merchantForm.value.merchant_name_en,
				merchant_name_ar: merchantForm.value.merchant_name_ar,
				merchant_name_he: merchantForm.value.merchant_name_he,
				merchant_address: merchantForm.value.merchant_address,
				id_number: merchantForm.value.id_number,
				password: merchantForm.value.password,
				created_by: this.userRegistId
			};

			this.spinner.show();

			
			this.service.Post(addNewMerchantByAdmin.POST, model).subscribe({
				next: (response: any) => {
					
					if (response.status === 400 || response.status === 403) {
						let errorMessage = "";
						switch (this.curentLang) {
							case "ar":
								errorMessage = response.messageAr || this.translate.instant('merchant-info.errors.unknownError');
								break;
							case "en":
								errorMessage = response.messageEn || this.translate.instant('merchant-info.errors.unknownError');
								break;
							case "he":
								errorMessage = response.messageHe || this.translate.instant('merchant-info.errors.unknownError');
								break;
							default:
								errorMessage = this.translate.instant('merchant-info.errors.unknownError');
						}
						Swal.fire({
							icon: 'error',
							title: errorMessage,
						});
					} else {
						
						let successMessage = "";
						switch (this.curentLang) {
							case "ar":
								successMessage = response.messageAr || this.translate.instant('merchant-info.notifications.saveSuccess');
								break;
							case "en":
								successMessage = response.messageEn || this.translate.instant('merchant-info.notifications.saveSuccess');
								break;
							case "he":
								successMessage = response.messageHe || this.translate.instant('merchant-info.notifications.saveSuccess');
								break;
							default:
								successMessage = this.translate.instant('merchant-info.notifications.saveSuccess');
						}
						Swal.fire({
							icon: 'success',
							title: successMessage,
						});
						this.modalService.dismissAll();
						this.getAllMerchantInfo();
						this.merchantForm.reset({
							phone_number: '',
							user_name: '',
							password: '',
							merchant_name_en: '',
							merchant_name_ar: '',
							merchant_name_he: '',
							merchant_address: '',
							id_number: ''
						});
					}
					this.spinner.hide();
				},
				error: (error: any) => {
					
					Swal.fire({
						icon: 'error',
						title: error.message || this.translate.instant('merchant-info.errors.unknownError'),
						text: error.message_ar || error.message_en || error.error_en || error.error_ar || this.translate.instant('merchant-info.errors.serverError'),
					});
					this.spinner.hide();
				}
			});
		}
	};

	
	/**
	 * @description Validates if the keyboard event corresponds to a number.
	 * Prevents non-numeric input.
	 * @param {KeyboardEvent} event - The keyboard event.
	 * @returns {boolean | undefined} True if the input is a number, otherwise undefined (due to preventDefault).
	 */
	isNumber(event: KeyboardEvent) {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			event.preventDefault();
		} else {
			return true;
		}
	}

	
	/**
	 * @description Toggles the visibility of the password input field.
	 */
	showPassword() {
		this.show = !this.show;
		const passwordInput = document.querySelector('input[name="login[password]"]') as HTMLInputElement;
		if (passwordInput) {
			passwordInput.focus();
		}
		this.handlePasswordValidation(this.merchantForm);
	}

	
	/**
	 * @description Marks the password control as touched to trigger validation messages.
	 * @param {FormGroup} formGroup - The form group containing the password control.
	 */
	handlePasswordValidation(formGroup: FormGroup) {
		const passwordControl = formGroup.get('password');
		if (passwordControl) {
			passwordControl.markAsTouched();
		}
	}

	
	/**
	 * @description Fetches all merchant information from the backend.
	 */
	getAllMerchantInfo() {
		this.spinner.show();
		this.service.getAllMerchantInfo().subscribe({
			next: res => {
				const rows = Array.isArray(res) ? res : res != null ? [res] : [];

				this.merchantInfoData = rows.map(merchant => {
					return {
						...merchant,
						merchant_name_en: merchant.merchant_name_en || '',
						merchant_name_ar: merchant.merchant_name_ar || '',
						merchant_name_he: merchant.merchant_name_he || '',
						merchant_address: merchant.merchant_address || ''
					};
				});

				const user = this.merchantInfoData[0]?.users?.find(user => user.user_type === 100);
				if (user) {
					this.MerchantPhone = this.formatPhoneNumber(user.phone_number);
				}
				this.spinner.hide();
			},
			error: error => {
				this.spinner.hide();
			}
		});
	};

	
	/**
	 * @description Sets the merchant ID.
	 * @param {number} id - The merchant ID.
	 */
	getId(id: number) {
		this.merchantId = id;
	};

	
	/**
	 * @description Opens a modal with extra-large size.
	 * @param {any} content - The template reference for the modal content.
	 */
	openXl(content: any) {
		this.modalService.open(content, { size: 'xl', centered: true });
	};

	
	/**
	 * @description Changes the status of a merchant (active/inactive).
	 * @param {number} id - The ID of the merchant.
	 * @param {any} merchant_status - The current status of the merchant.
	 */
	changeStatus(id: number, merchant_status: any) {
		this.spinner.show();

		let model = {
			"merchant_status": merchant_status == 1 ? 59 : 1,
			"updated_by": this.userRegistId
		}

		this.service.changeMerchantStatus(id, model).subscribe(({
			next: res => {
				if (res.status == 200) {
					
					Swal.fire({
						icon: 'success',
						title: this.translate.instant('merchant-info.changeStatus.success'),
					})
					this.getAllMerchantInfo();
					this.spinner.hide();
				}
			},
			error: err => {
				Swal.fire({
					icon: "error",
					title: err.error.message[0]
				});
				this.spinner.hide();
			}
		}))
	};

	
	/**
	 * @description Sets the company ID.
	 * @param {any} companyId - The company ID.
	 */
	getCompanyId(companyId: any) {
		this.CompanyId = companyId;
		
		
		
		
		
		
	}

	
	/**
	 * @description Handles the change event when a company is selected from the dropdown.
	 * Sets the selected company as default and updates the logo.
	 * @param {any} companyId - The ID of the selected company.
	 */
	onCompanyChange(companyId: any): void {
		
		this.CompanyId = companyId;

		
		localStorage.setItem('companyDefault', companyId.toString());

		
		this.setCompanyDefault();
		this.updateSelectedCompanyLogo();
		// Update allowed invoice types when company changes
		this.updateAllowedInvoiceTypes(companyId);
		this.onHeaderCompanyChanged(companyId);
	}

	/** Company from header / localStorage (same source as account statement PDF). */
	private getHeaderCompanyId(): number | null {
		const raw =
			this.selectedCompany ??
			this.CompanyId ??
			localStorage.getItem('companyDefault');
		if (raw == null || raw === '') {
			return null;
		}
		const id = Number(raw);
		return Number.isFinite(id) && id > 0 ? id : null;
	}

	private onCompanyChangedHandler: EventListener | null = null;

	/** Reload account-statement customers when header company changes. */
	private onHeaderCompanyChanged(companyId?: number | string | null): void {
		if (companyId != null && companyId !== '') {
			const id = Number(companyId);
			if (Number.isFinite(id) && id > 0) {
				this.CompanyId = id;
				this.selectedCompany = id;
			}
		}
		this.customerAccountStatementForm?.patchValue({ selectedCustomer: null });
		this.selectedCustomer = null;
		this.getAllCustomersForAccountStatement({ skipSpinner: true });
	}
	
	/**
	 * @description Updates the allowed invoice types based on the selected company.
	 * @param {any} companyId - The ID of the selected company.
	 */
	updateAllowedInvoiceTypes(companyId: any): void {
		if (companyId) {
			// First, ensure companies are loaded in CompaniesService
			this.companiesService.getCompanies().subscribe({
				next: (companies) => {
					// Companies are now loaded, get invoice types
					this.allowedInvoiceTypes = this.companiesService.getCompanyInvoiceTypes(companyId);
				},
				error: (error) => {
					console.warn('Could not load companies for invoice type filtering:', error);
					// Fallback: show all invoice types if companies can't be loaded
					this.allowedInvoiceTypes = [];
				}
			});
		} else {
			this.allowedInvoiceTypes = [];
		}
	}
	
	/**
	 * Sales report & shared labels: Hebrew → English → Arabic (same order regardless of UI language).
	 */
	getCompanyDisplayLabel(company: {
		company_name_he?: string | null;
		company_name_en?: string | null;
		company_name_ar?: string | null;
	} | null | undefined): string {
		if (!company) return '';
		const he = company.company_name_he?.trim();
		const en = company.company_name_en?.trim();
		const ar = company.company_name_ar?.trim();
		return he || en || ar || '';
	}

	/** Customer dropdown / statements: same HE → EN → AR fallback as companies. */
	getCustomerDisplayLabel(customer: any): string {
		if (!customer) return '';
		const he = String(customer.customer_name_he || customer.customer_customer_name_he || '').trim();
		const en = String(customer.customer_name_en || customer.customer_customer_name_en || '').trim();
		const ar = String(customer.customer_name_ar || customer.customer_customer_name_ar || '').trim();
		return he || en || ar || '';
	}

	private normalizeCustomersDropdownResponse(res: any): any[] {
		if (res == null) return [];
		if (Array.isArray(res)) return res;

		const arrayKeys = ['customers', 'data', 'rows', 'results', 'items', 'records', 'list', 'payload', 'result', 'body', 'response'];
		for (const key of arrayKeys) {
			const v = res[key];
			if (Array.isArray(v)) return v;
		}

		for (const wrapKey of arrayKeys) {
			const inner = res[wrapKey];
			if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
				for (const key of arrayKeys) {
					const arr = inner[key];
					if (Array.isArray(arr)) return arr;
				}
			}
		}

		for (const key of Object.keys(res)) {
			const v = res[key];
			if (!Array.isArray(v) || v.length === 0) continue;
			const first = v[0];
			if (first && typeof first === 'object' && ('customer_id' in first || 'customer_customer_id' in first)) {
				return v;
			}
		}

		return [];
	}

	getSelectedCompanyName(): string {
		// First try to get from companyData array
		if (this.selectedCompany && this.companyData && this.companyData.length > 0) {
			const selectedCompany = this.companyData.find(company => company.company_id === this.selectedCompany);
			if (selectedCompany) {
				return (
					selectedCompany.company_display_label ||
					this.getCompanyDisplayLabel(selectedCompany)
				);
			}
		}

		// Fallback to localStorage values if companyData hasn't loaded yet
		if (this.selectedCompany) {
			return this.getCompanyDisplayLabel({
				company_name_he: this.company_name_he,
				company_name_en: this.company_name_en,
				company_name_ar: this.company_name_ar,
			});
		}

		return '';
	}
	
	/**
	 * @description Checks if an invoice type is allowed for the selected company.
	 * @param {string} route - The route path for the invoice type.
	 * @returns {boolean} True if the invoice type is allowed, false otherwise.
	 */
	isInvoiceTypeAllowed(route: string): boolean {
		// Map routes to invoice type codes
		const routeToInvoiceTypeMap: { [key: string]: number } = {
			'/dashboard/add-invoice': 305, // Tax Invoice
			'/dashboard/add-receipts': 400, // Receipt
			'/dashboard/add-invoice-with-receipt': 320, // Invoice With Receipt
			'/dashboard/add-finaical-request': 332, // Financial Request
			'/dashboard/add-reverce-invoice': 330, // Reverse Invoice
			'/dashboard/add-mission': 200, // Mission
			'/dashboard/add-offer-price': 0, // Offer Price
			'/dashboard/add-order': 100 // Order
		};
		
		const invoiceTypeCode = routeToInvoiceTypeMap[route];
		if (invoiceTypeCode === undefined) {
			// If route is not in map, allow it (for backward compatibility)
			return true;
		}
		
		// If no company is selected or no allowed types, show all
		if (!this.allowedInvoiceTypes || this.allowedInvoiceTypes.length === 0) {
			return true;
		}
		
		return this.allowedInvoiceTypes.includes(invoiceTypeCode);
	}

	
	/**
	 * @description Sets the selected company as the default company for the user/merchant.
	 */
	setCompanyDefault(): void {
		this.spinner.show();

		const model = {
			company_default: this.CompanyId,
			updated_by: this.userRegistId
		};

		this.service.setCompanyDefault(model).subscribe({
			next: (res) => {
				if (res.status === 200) {
					
					
					
					
					

					
					this.spinner.hide();
					window.location.reload(); 
				}
			},
			error: (err) => {
				Swal.fire({
					icon: 'error',
					title: err.error.message[0]
				});
				this.spinner.hide();
			}
		});
	}

	
	/**
	 * @description Updates the displayed company logo and name based on the selected company.
	 * Stores company details in local storage.
	 */
	updateSelectedCompanyLogo(): void {
		const selectedCompany = this.companyData.find(company => company.company_id === this.CompanyId);
		if (selectedCompany) {
			this.selectedCompanyLogo = selectedCompany.logo_url;
			localStorage.setItem('selectedCompanyLogo', selectedCompany.logo_url);

			
			this.companyNameAr = selectedCompany.company_name_ar;
			this.companyNameEn = selectedCompany.company_name_en;
			this.companyNameHe = selectedCompany.company_name_he;

			localStorage.setItem('company_name_ar', this.companyNameAr);
			localStorage.setItem('company_name_en', this.companyNameEn);
			localStorage.setItem('company_name_he', this.companyNameHe);

		} else {
			this.selectedCompanyLogo = null;
			localStorage.removeItem('selectedCompanyLogo');
		}
	}

	/**
	 * @description Angular lifecycle hook that is called after data-bound properties of a directive are initialized.
	 * Initializes forms, fetches initial data, and sets up language change subscriptions.
	 */
	ngOnInit() {
		this.user_type = JSON.parse(localStorage.getItem('user_type'));
		const isMerchantHomeUser = this.user_type === 100 || this.user_type === 101;
		const openReports = this.route.snapshot.queryParamMap.get('openReports') === '1';
		if (isMerchantHomeUser && !openReports) {
			this.router.navigate(['/dashboard/dashboard'], { replaceUrl: true });
			return;
		}

		this.getAllMerchantInfo();
		this.getProfileInfo();
		this.getAllCompaniesInfo();
		this.layoutVersion = localStorage.getItem("layout_version");
		if (this.layoutVersion == null || this.layoutVersion == undefined) {
			localStorage.setItem("layout_version", "light-only");
			this.layoutVersion = "light-only";
		} else {
			this.layoutVersion = localStorage.getItem("layout_version");
			if (this.layoutVersion === "dark-only") {
				document.body.classList.add("dark-only");
			} else {
				document.body.classList.add("light-only");

			}
		}
		this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
		this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
		this.user_type = JSON.parse(localStorage.getItem('user_type'));

		this.companyDefault = localStorage.getItem('companyDefault');
		const storedCompanyId = localStorage.getItem('companyDefault');
		const storedCompanyLogo = localStorage.getItem('selectedCompanyLogo');
		this.company_name_ar = localStorage.getItem('company_name_ar');
		this.company_name_en = localStorage.getItem('company_name_en');
		this.company_name_he = localStorage.getItem('company_name_he');
		if (this.companyDefault) {
			// Ensure the selectedCompany type matches optionValue (number) for PrimeNG binding
			this.selectedCompany = Number(this.companyDefault);
			this.company_name_ar = this.company_name_ar;
			this.company_name_en = this.company_name_en;
			this.company_name_he = this.company_name_he;
			this.selectedCompanyName = this.getCompanyDisplayLabel({
				company_name_he: this.company_name_he,
				company_name_en: this.company_name_en,
				company_name_ar: this.company_name_ar,
			});
			// Initialize allowed invoice types for the default company
			this.updateAllowedInvoiceTypes(Number(this.companyDefault));
		}

		if (storedCompanyId && storedCompanyLogo) {
			this.CompanyId = Number(storedCompanyId);
			this.selectedCompanyLogo = storedCompanyLogo;
		}

		this.getAllCustomersForAccountStatement();

		this.onCompanyChangedHandler = ((e: Event) => {
			const companyId = (e as CustomEvent<{ companyId?: number }>).detail?.companyId;
			if (companyId != null) {
				this.onHeaderCompanyChanged(companyId);
			}
		}) as EventListener;
		window.addEventListener('companyChanged', this.onCompanyChangedHandler);

		this.reportsForm = this.fb.group({
			companyId: [null],
			startDate: [''],
			endDate: [''],
			document_type: [1],
			lang: getDefaultReportLanguage()
		});


		const currentDate = new Date();
		const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
		const endDate = currentDate; 

		this.reportsForm.patchValue({
			startDate: this.formatDate(startDate),
			endDate: this.formatDate(endDate)
		});


		this.fromDate = this.formatDate(startDate);
		this.toDate = this.formatDate(endDate);

		// Get default account type based on company type
		const defaultAccountType = this.getDefaultAccountType();

		this.customerAccountStatementForm = this.fb.group({
			startDate: [this.formatDate(startDate)],
			endDate: [this.formatDate(endDate)], 
			selectedCustomer: [null, Validators.required],
			selectedPeriod: [1, Validators.required],
			accountType: [defaultAccountType, Validators.required],  // false = tax invoice, true = financial claim
			lang: [getDefaultReportLanguage()]
		});


		
		this.translate.onLangChange.subscribe(() => {
			this.periodOptions = [
				{ label: this.translate.instant('merchant-info.common.currentMonth'), value: 1 },
				{ label: this.translate.instant('merchant-info.common.lastMonth'), value: 2 },
				{ label: this.translate.instant('merchant-info.common.lastTwoMonths'), value: 5 },
				{ label: this.translate.instant('merchant-info.common.startOfYear'), value: 3 },
				{ label: this.translate.instant('merchant-info.common.lastYear'), value: 4 }
			];
			
			this.curentLang = localStorage.getItem('curentLang');
		});
		this.loadSubscriptionExpiringNotice();
		this.updateIsMobile();

		if (this.route.snapshot.queryParamMap.get('openReports') === '1') {
			setTimeout(() => this.showReportOptions(), 0);
		}
		this.route.queryParamMap.subscribe((params) => {
			if (params.get('openReports') === '1') {
				setTimeout(() => this.showReportOptions(), 0);
			}
		});
	}

	private subscriptionExpiringDismissStorageKey(): string {
		return `merchantInfoSubscriptionExpiringDismissedAt_${this.merchantId}`;
	}

	private isSubscriptionExpiringDismissedWithinDay(): boolean {
		const raw = localStorage.getItem(this.subscriptionExpiringDismissStorageKey());
		if (!raw) {
			return false;
		}
		const t = Number(raw);
		if (Number.isNaN(t)) {
			return false;
		}
		return Date.now() - t < MerchantComponent.SUB_EXPIRING_DISMISS_MS;
	}

	private daysRemainingUntilSubscriptionEnd(status: InvoiceSubscriptionStatus): number | null {
		if (status.subscription == null) {
			return null;
		}
		const fromApi = status.days_remaining;
		if (fromApi != null && !Number.isNaN(Number(fromApi))) {
			return Math.max(0, Math.floor(Number(fromApi)));
		}
		const end = status.subscription.end_date;
		if (!end) {
			return null;
		}
		const endMs = new Date(end).getTime();
		if (Number.isNaN(endMs)) {
			return null;
		}
		return Math.max(0, Math.ceil((endMs - Date.now()) / 86400000));
	}

	private shouldLoadSubscriptionExpiryBanner(): boolean {
		const t = Number(this.user_type);
		// Merchant / related roles that manage invoice subscription for merchant_id
		return t === 100 || t === 101 || t === 300 || t === 301;
	}

	/** Loads subscription status and shows a dismissible notice when ending within 7 days (skipped if auto_renew is on). */
	loadSubscriptionExpiringNotice(): void {
		this.showSubscriptionExpiringBanner = false;
		this.subscriptionExpiringDaysRemaining = null;
		if (!this.shouldLoadSubscriptionExpiryBanner()) {
			return;
		}
		if (this.merchantId === null || this.merchantId === undefined || this.merchantId === '') {
			return;
		}
		if (this.isSubscriptionExpiringDismissedWithinDay()) {
			return;
		}

		this.invoiceSubscriptionsV2.getStatus().subscribe({
			next: (status) => {
				if (!status?.subscription || !status.is_active || status.is_expired) {
					return;
				}
				if (String(status.subscription.status).toLowerCase() !== 'active') {
					return;
				}
				if (status.subscription.auto_renew === true) {
					return;
				}
				const daysLeft = this.daysRemainingUntilSubscriptionEnd(status);
				if (daysLeft === null || daysLeft > MerchantComponent.SUB_EXPIRING_MAX_DAYS) {
					return;
				}
				if (this.isSubscriptionExpiringDismissedWithinDay()) {
					return;
				}
				this.subscriptionExpiringDaysRemaining = daysLeft;
				this.showSubscriptionExpiringBanner = true;
				this.cdRef.detectChanges();
			},
			error: () => {
				this.showSubscriptionExpiringBanner = false;
			},
		});
	}

	goToInvoiceSubscriptions(): void {
		this.router.navigate(['/dashboard/invoice-subscriptions']);
	}

	dismissSubscriptionExpiringBanner(event: Event): void {
		event.stopPropagation();
		localStorage.setItem(this.subscriptionExpiringDismissStorageKey(), String(Date.now()));
		this.showSubscriptionExpiringBanner = false;
	}

	/**
	 * @description Fetches all customers for the account statement dropdown.
	 * Uses a specific endpoint for dropdown data.
	 */
	getAllCustomersForAccountStatement(options?: { skipSpinner?: boolean }) {
		const companyId = this.getHeaderCompanyId();
		if (!companyId) {
			this.customerAccountStatementUserData = [];
			this.customerAccountStatementForm?.patchValue({ selectedCustomer: null });
			this.cdRef.detectChanges();
			return;
		}
		if (!options?.skipSpinner) {
			this.spinner.show();
		}
		this.service.getCustomersByCompanyId(companyId).subscribe({
			next: (res) => {
				const customers = this.normalizeCustomersDropdownResponse(res);
				this.customerAccountStatementUserData = customers
					.map((customer: any) => {
						const rawId = customer.customer_id ?? customer.customer_customer_id ?? customer.user_id;
						const user_id = Number(rawId);
						let customer_display_label = this.getCustomerDisplayLabel(customer);
						if (!customer_display_label && Number.isFinite(user_id)) {
							customer_display_label = `#${user_id}`;
						}
						return {
							user_id,
							customer_display_label,
							user_name: customer_display_label,
						};
					})
					.filter((row: { user_id: number }) => Number.isFinite(row.user_id));
				const selectedId = this.customerAccountStatementForm?.get('selectedCustomer')?.value;
				if (
					selectedId != null &&
					!this.customerAccountStatementUserData.some((c) => c.user_id === Number(selectedId))
				) {
					this.customerAccountStatementForm.patchValue({ selectedCustomer: null });
					this.selectedCustomer = null;
				}
				if (!options?.skipSpinner) {
					this.spinner.hide();
				}
				this.cdRef.detectChanges();
			},
			error: () => {
				this.customerAccountStatementUserData = [];
				if (!options?.skipSpinner) {
					this.spinner.hide();
				}
				this.cdRef.detectChanges();
			},
		});
	}

	ngOnDestroy(): void {
		if (this.onCompanyChangedHandler) {
			window.removeEventListener('companyChanged', this.onCompanyChangedHandler);
			this.onCompanyChangedHandler = null;
		}
	}

	/**
	 * @description Fetches profile information for the current user/merchant.
	 */
	getProfileInfo() {
		this.spinner.show();
		this.service.getProfileInfo().subscribe({
			next: res => {
				this.profileData = res;

				const data = this.profileData?.lookupDetailsUserType?.lookupDetailEnName;
				localStorage.setItem("userType_en", data);


				this.spinner.hide();
				this.navService.requestSidebarLeftMenuRefresh();
			},
			error: error => {
				this.spinner.hide();
			}
		});
	};

	/**
	 * @description Executes functions to open the image upload modal and set initial values.
	 * @param {number} userId - The ID of the user (currently uses `this.userRegistId`).
	 * @param {any} uploadData - The template reference for the upload modal.
	 */
	executeFunctions(userId: number, uploadData: any) {
		this.openVerticallyCentered2(uploadData, userId);
		this.setValue(userId);
		const selectedProfile = this.profileData;

		if (selectedProfile) {
			this.currentImageUrl = selectedProfile?.image_url;
		}
	};


	/**
	 * @description Opens a vertically centered modal for image upload.
	 * @param {any} uploadData - The template reference for the modal content.
	 * @param {any} userId - The ID of the user (used to set `this.userRegistId`).
	 */
	openVerticallyCentered2(uploadData: any, userId: any) {
		this.modalService.open(uploadData, { centered: true });
		userId = this.userRegistId;

	};

	/**
	 * @description Sets the values for the image upload form.
	 * @param {number} userId - The ID of the user (currently unused in the method body).
	 */
	setValue(userId: number) {
		const userToUpdate = this.profileData;

		if (userToUpdate) {
			this.uploadImage?.get('id')?.setValue(userToUpdate.company_id);
			this.uploadImage?.get('file')?.setValue(this.currentImageUrl);
		}
	};

	/**
	 * @description Handles the file change event when a user selects an image.
	 * Reads the selected file and displays a preview.
	 * @param {any} event - The file input change event.
	 */
	onFileChanged(event: any) {
		this.file = event.target.files[0];

		if (event.target.files && event.target.files[0]) {
			var reader = new FileReader();

			reader.onload = (event: any) => {
				this.currentImageUrl = event.target.result;
				this.cdRef.detectChanges();
			}

			reader.readAsDataURL(event.target.files[0]);

		};
	};

	/**
	 * @description Uploads the selected file (profile image) to the server.
	 */
	uploadFile() {

		const formData = new FormData();
		if (this.file != null) {
			formData.append("file", this.file, this.file.name);
		}
		this.spinner.show();
		this.service.updateUserImage(this.userRegistId, formData).subscribe(({
			next: response => {
				Swal.fire({
					icon: 'success',
					title: this.curentLang === 'ar' ? response.messageAr : (this.curentLang === 'en' ? response.messageEn : response.messageHe)
				});
				this.modalService.dismissAll();
				this.getProfileInfo();
				this.uploadImage.reset();
				this.spinner.hide();
				if (response.status == 400) {
					Swal.fire(response.message);
					this.spinner.hide();
				}
			},
			error: error => {
				Swal.fire(error.message);
				this.spinner.hide();
			}

		}));
	};

	
	/**
	 * @description Formats a phone number string by cleaning non-digit characters and ensuring it ends with '+'.
	 * @param {string} phoneNumber - The phone number to format.
	 * @returns {string} The formatted phone number.
	 */
	formatPhoneNumber(phoneNumber: string): string {
		
		const cleaned = phoneNumber.replace(/[^ \d]/g, '');

		
		if (!cleaned.endsWith('+')) {
			return `${cleaned}+`;
		}

		return cleaned;
	};

	
	/**
	 * @description Opens a modal (content2 - Invoice Types) with large size.
	 * Merchants (100/101): same quota gate as all-documents / invoices-v2 before choosing a new document type.
	 * @param {any} content2 - The template reference for the modal content.
	 */
	openXl2(content2: any) {
		const userType = Number(this.user_type);
		if (userType === 100 || userType === 101) {
			this.invoiceSubscriptionsV2.canIssueDocument().subscribe({
				next: (eligibility) => {
					if (!eligibility.allowed) {
						this.showDocumentQuotaBlockedSwal(eligibility);
						return;
					}
					this.modalService.open(content2, { size: 'lg' });
				},
				error: () => {
					this.modalService.open(content2, { size: 'lg' });
				},
			});
			return;
		}
		this.modalService.open(content2, { size: 'lg' });
	}

	private showDocumentQuotaBlockedSwal(eligibility: CanIssueDocumentResponse): void {
		const lang = this.curentLang || 'ar';
		Swal.fire({
			icon: 'warning',
			title:
				lang === 'ar'
					? 'لا يمكن إصدار الفاتورة'
					: lang === 'he'
						? 'לא ניתן להנפיק חשבונית'
						: 'Cannot Issue Invoice',
			html:
				lang === 'ar'
					? `وصلت للحد الأقصى للفواتير في اشتراكك الحالي (<b>${eligibility.documents_used}/${eligibility.limit}</b>).<br>يرجى شراء إضافة مستندات أو الترقية.`
					: lang === 'he'
						? `הגעת למגבלת המסמכים במנוי הנוכחי שלך (<b>${eligibility.documents_used}/${eligibility.limit}</b>).<br>אנא רכוש הרחבת מסמכים או שדרג.`
						: `You have reached the document limit of your current subscription (<b>${eligibility.documents_used}/${eligibility.limit}</b>).<br>Please purchase a document extension or upgrade.`,
			confirmButtonText:
				lang === 'ar' ? 'إدارة الاشتراك' : lang === 'he' ? 'ניהול מנוי' : 'Manage Subscription',
			showCancelButton: true,
			cancelButtonText: lang === 'ar' ? 'إلغاء' : lang === 'he' ? 'ביטול' : 'Cancel',
			confirmButtonColor: '#E62E2D',
		}).then((result) => {
			if (result.isConfirmed) {
				this.router.navigate(['/dashboard/invoice-subscriptions']);
			}
		});
	}

	
	/**
	 * @description Opens a modal (content3 - Users Info) with large size.
	 * @param {any} content3 - The template reference for the modal content.
	 */
	openXl3(content3: any) {
		this.modalService.open(content3, { size: 'lg' });
	};

	
	/**
	 * @description Opens a modal (content4 - Reports) with extra-large size.
	 * @param {any} content4 - The template reference for the modal content.
	 */
	openXl4(content4: any) {
		this.modalService.open(content4, { size: 'xl' });
	};

	
	/**
	 * @description Opens a modal (content5 - Customer Account Statement) with extra-large size.
	 * @param {any} content5 - The template reference for the modal content.
	 */
	openXl5(content5: any) {
		this.modalService.open(content5, { size: 'xl' });
	};

	
	/**
	 * @description Opens a modal (content6 - Products Info) with extra-large size.
	 * @param {any} content6 - The template reference for the modal content.
	 */
	openXl6(content6: any) {
		this.modalService.open(content6, { size: 'xl' });
	};

	
	/**
	 * @description Opens a modal (content7 - Companies Info) with extra-large size.
	 * @param {any} content7 - The template reference for the modal content.
	 */
	openXl7(content7: any) {
		this.modalService.open(content7, { size: 'xl' });
	};

	
	/**
	 * @description Fetches all users based on the current user's token.
	 * Populates `this.userData` for dropdowns.
	 */
	getALLUsersByBasedToken() {
		this.spinner.show();
		this.service.getALLUsersByBasedToken().subscribe({
			next: (res) => {
				this.userData = res.map((user: any) => ({
					user_id: user.user_id,
					user_name: user.user_name
				})); 
				this.spinner.hide();
			},
			error: (error) => {
				console.error('Error fetching users:', error);
				this.spinner.hide();
			}
		});
	}

	
	/**
	 * @description Filters report dates based on a selected period (e.g., current month, last month).
	 * Updates relevant form groups with the new date range.
	 * @param {any} event - The event object from the period selection dropdown.
	 * Can be a standard event or a PrimeNG dropdown event object.
	 */
	filterMonth(event: any) {

		let selectedValue: number;
		if (event && event.target && event.target.value !== undefined) {
			selectedValue = parseInt(event.target.value, 10);
		} else if (typeof event === 'number') {
			selectedValue = event;
		} else if (event && event.value !== undefined) { 
			selectedValue = event.value;
		}
		 else {
			return;
		}

		if (isNaN(selectedValue)) {
			return;
		}
		
		const currentDate = new Date();

		let fromDate: Date;
		let toDate: Date;

		switch (selectedValue) {
			case 1: 
				fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
				toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
				break;
			case 2: 
				fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
				toDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
				break;
			case 3: 
				fromDate = new Date(currentDate.getFullYear(), 0, 1);
				toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
				break;
			case 4: 
				fromDate = new Date(currentDate.getFullYear() - 1, 0, 1);
				toDate = new Date(currentDate.getFullYear() - 1, 11, 31);
				break;
			case 5: 
				fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 2, 1);
				toDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
				break;
			default:
				return;
		}

		this.fromDate = this.formatDate(fromDate);
		this.toDate = this.formatDate(toDate);
		this.selectedPeriod = selectedValue;

		this.documentForm.patchValue({
			startDate: this.fromDate,
			endDate: this.toDate,
			period: selectedValue
		});

		this.reportsForm.patchValue({
			startDate: this.fromDate,
			endDate: this.toDate
		});

		this.customerAccountStatementForm.patchValue({
			startDate: this.fromDate,
			endDate: this.toDate,
			selectedPeriod: selectedValue
		});

		// Convert string dates back to Date objects for the form
		const startDateObj = this.parseDateString(this.fromDate);
		const endDateObj = this.parseDateString(this.toDate);
		
		this.salesReportForm.patchValue({
			startDate: startDateObj,
			endDate: endDateObj,
			selectedPeriod: selectedValue
		});
		
		this.cdRef.detectChanges(); 
	}

	
	/**
	 * @description Formats a Date object or a date string into 'dd/MM/yyyy' format.
	 * @param {Date | string | null} date - The date to format.
	 * @returns {string} The formatted date string, or an empty string if the input is invalid.
	 */
	formatDate(date: Date | string | null): string {
		if (!date || !(date instanceof Date)) {
			
			return '';
		}
		const day = ('0' + date.getDate()).slice(-2);
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	}

	/**
	 * @description Formats a Date object for API consumption (YYYY-MM-DD format).
	 * @param {Date} date - The date to format.
	 * @returns {string} The formatted date string in YYYY-MM-DD format.
	 */
	formatDateForAPI(date: Date): string {
		if (!date || !(date instanceof Date)) {
			return '';
		}
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		return `${year}-${month}-${day}`;
	}

	/**
	 * @description Parses a date string in DD/MM/YYYY format to a Date object.
	 * @param {string} dateString - The date string to parse.
	 * @returns {Date} The parsed Date object.
	 */
	parseDateString(dateString: string): Date {
		if (!dateString) return new Date();
		const parts = dateString.split('/');
		if (parts.length === 3) {
			// Assuming DD/MM/YYYY format
			const day = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
			const year = parseInt(parts[2], 10);
			return new Date(year, month, day);
		}
		return new Date(dateString);
	}

	
	/**
	 * @description Get max date for start date (should not exceed endDate)
	 * @returns {Date | null} - The maximum allowed date for start date
	 */
	getMaxStartDateForModal(): Date | null {
		const endDateValue = this.customerAccountStatementForm?.get('endDate')?.value;
		if (endDateValue instanceof Date && !isNaN(endDateValue.getTime())) {
			return endDateValue;
		}
		return null;
	}

	/**
	 * @description Get min date for end date (should not be before startDate)
	 * @returns {Date | null} - The minimum allowed date for end date
	 */
	getMinEndDateForModal(): Date | null {
		const startDateValue = this.customerAccountStatementForm?.get('startDate')?.value;
		if (startDateValue instanceof Date && !isNaN(startDateValue.getTime())) {
			return startDateValue;
		}
		return null;
	}

	/**
	 * @description Validates that start date is before end date in customer account statement form
	 * @returns {boolean} - True if dates are valid, false otherwise
	 */
	validateModalDateRange(): boolean {
		this.modalDateRangeError = '';
		
		const startDateValue = this.customerAccountStatementForm?.get('startDate')?.value;
		const endDateValue = this.customerAccountStatementForm?.get('endDate')?.value;

		if (!startDateValue || !endDateValue) {
			return true; // Allow empty dates
		}

		const startDate = startDateValue instanceof Date ? startDateValue : new Date(startDateValue);
		const endDate = endDateValue instanceof Date ? endDateValue : new Date(endDateValue);

		if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
			return true; // Invalid dates will be handled elsewhere
		}

		// Reset time to compare dates only
		startDate.setHours(0, 0, 0, 0);
		endDate.setHours(0, 0, 0, 0);

		if (startDate > endDate) {
			// Set error message
			if (this.curentLang === 'ar') {
				this.modalDateRangeError = 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية';
			} else if (this.curentLang === 'he') {
				this.modalDateRangeError = 'תאריך התחלה לא יכול להיות אחרי תאריך סיום';
			} else {
				this.modalDateRangeError = 'Start date cannot be after end date';
			}
			
			this.cdRef.detectChanges();
			return false;
		}

		// Clear error if validation passes
		this.modalDateRangeError = '';
		this.cdRef.detectChanges();
		return true;
	}

	/**
	 * @description Handles the change event when the 'From Date' is selected in a calendar.
	 * Updates `this.fromDate` and patches relevant form groups.
	 * @param {any} event - The date selection event from the calendar.
	 */
	onFromDateChange(event: any): void {
		const parsedDate = event instanceof Date ? event : new Date(event);
		if (!isNaN(parsedDate.getTime())) { 
			const formatted = this.formatDate(parsedDate);
			if (this.fromDate !== formatted) {
				this.fromDate = formatted;
				// Update forms with Date objects, not strings
				this.reportsForm.patchValue({ startDate: parsedDate }, { emitEvent: false });
				this.customerAccountStatementForm.patchValue({ startDate: parsedDate }, { emitEvent: false });
				this.salesReportForm.patchValue({ startDate: parsedDate }, { emitEvent: false });
				
				// Validate date range immediately after updating start date
				setTimeout(() => {
					this.validateModalDateRange();
					this.cdRef.detectChanges();
				}, 0);
			}
		} else {
		}
	}

	
	/**
	 * @description Handles the change event when the 'To Date' is selected in a calendar.
	 * Updates `this.toDate` and patches relevant form groups.
	 * @param {any} event - The date selection event from the calendar.
	 */
	onToDateChange(event: any): void {
		const parsedDate = event instanceof Date ? event : new Date(event);
		if (!isNaN(parsedDate.getTime())) { 
			const formatted = this.formatDate(parsedDate);
			if (this.toDate !== formatted) {
				this.toDate = formatted;
				// Update forms with Date objects, not strings
				this.reportsForm.patchValue({ endDate: parsedDate }, { emitEvent: false });
				this.customerAccountStatementForm.patchValue({ endDate: parsedDate }, { emitEvent: false });
				this.salesReportForm.patchValue({ endDate: parsedDate }, { emitEvent: false });
				
				// Validate date range immediately after updating end date
				setTimeout(() => {
					this.validateModalDateRange();
					this.cdRef.detectChanges();
				}, 0);
			}
		} else {
		}
	}

	/**
	 * @description Format input with automatic slashes (dd/mm/yyyy) - only when needed
	 * @param {string} value - The input value
	 * @param {boolean} forceFormat - Whether to force formatting even if already formatted
	 * @returns {string} - The formatted date string
	 */
	formatDateInputForModal(value: string, forceFormat: boolean = false): string {
		// If value already has slashes in correct positions, don't reformat while typing
		if (!forceFormat && value.includes('/')) {
			const parts = value.split('/');
			// If it already looks formatted (has slashes), return as-is
			if (parts.length <= 3 && parts.every(p => /^\d*$/.test(p))) {
				return value;
			}
		}
		
		// Remove all non-digits
		const digits = value.replace(/\D/g, '');
		
		// Limit to 8 digits (ddmmyyyy)
		const limited = digits.substring(0, 8);
		
		// Add slashes automatically
		if (limited.length <= 2) {
			return limited;
		} else if (limited.length <= 4) {
			return limited.substring(0, 2) + '/' + limited.substring(2);
		} else {
			return limited.substring(0, 2) + '/' + limited.substring(2, 4) + '/' + limited.substring(4);
		}
	}

	/**
	 * @description Auto-correct invalid date values
	 * @param {number} day - The day value
	 * @param {number} month - The month value
	 * @param {number} year - The year value
	 * @returns {object} - Corrected date values
	 */
	correctDateValuesForModal(day: number, month: number, year: number): { day: number; month: number; year: number } {
		// Correct month (1-12)
		if (month < 1) month = 1;
		if (month > 12) month = 12;
		
		// Correct year - be smarter about it
		if (year < 100) {
			// 2-digit year: assume 20xx
			year += 2000;
		} else if (year < 1900) {
			// Very old year, use current year instead
			year = new Date().getFullYear();
		} else if (year > 2100) {
			// Future year beyond 2100, use current year instead of clamping to 1900
			year = new Date().getFullYear();
		}
		
		// Get days in month
		const daysInMonth = new Date(year, month, 0).getDate();
		
		// Correct day
		if (day < 1) day = 1;
		if (day > daysInMonth) day = daysInMonth;
		
		return { day, month, year };
	}

	/**
	 * @description Parse and auto-correct date string in dd/mm/yy or dd/mm/yyyy format for modal inputs
	 * @param {string} dateString - The date string to parse
	 * @returns {Date | null} - The parsed Date object or null if invalid
	 */
	parseDateStringForModal(dateString: string): Date | null {
		if (!dateString || dateString.trim() === '') {
			return null;
		}

		// Remove any whitespace and clean the string
		const cleaned = dateString.trim().replace(/\s+/g, '');
		
		// Try to match date pattern (flexible - allows partial dates)
		const datePattern = /^(\d{1,2})\/?(\d{0,2})\/?(\d{0,4})$/;
		const match = cleaned.match(datePattern);
		
		if (!match) {
			return null;
		}

		let day = parseInt(match[1] || '1', 10);
		let month = parseInt(match[2] || '1', 10);
		let year = parseInt(match[3] || new Date().getFullYear().toString(), 10);
		
		// If no year provided, use current year
		if (!match[3] || match[3] === '') {
			year = new Date().getFullYear();
		}
		
		// Auto-correct invalid values
		const corrected = this.correctDateValuesForModal(day, month, year);
		day = corrected.day;
		month = corrected.month;
		year = corrected.year;
		
		// Create date (month is 0-indexed in Date constructor)
		const date = new Date(year, month - 1, day);
		
		// Validate the date is correct
		if (date.getDate() === day && 
			date.getMonth() === month - 1 && 
			date.getFullYear() === year) {
			return date;
		}
		
		return null;
	}

	/**
	 * @description Handles manual input event for dates in customer account statement modal - minimal interference
	 * @param {any} event - The input event from the calendar
	 * @param {string} fieldName - The field name ('startDate' or 'endDate')
	 */
	onCustomerStatementDateInput(event: any, fieldName: string): void {
		const input = event?.target || event;
		if (!input) return;
		
		let inputValue = input.value || '';
		
		// Only format if user typed digits without slashes (e.g., typing "101" should become "10/1")
		// But don't reformat if they already have slashes in correct positions
		if (!inputValue.includes('/') && /^\d+$/.test(inputValue) && inputValue.length > 2) {
			const formatted = this.formatDateInputForModal(inputValue, true);
			if (formatted !== inputValue) {
				const cursorPos = input.selectionStart || 0;
				input.value = formatted;
				// Maintain cursor position
				const newPos = Math.min(cursorPos + (formatted.length - inputValue.length), formatted.length);
				setTimeout(() => {
					input.setSelectionRange(newPos, newPos);
				}, 0);
			}
		}
		
		// Don't parse while typing - let user finish typing first
		// Only validate on blur
	}

	/**
	 * @description Handles blur event for dates in customer account statement modal - final validation and correction
	 * @param {any} event - The blur event from the calendar
	 * @param {string} fieldName - The field name ('startDate' or 'endDate')
	 */
	onCustomerStatementDateBlur(event: any, fieldName: string): void {
		const input = event?.target || event;
		if (!input) return;
		
		let inputValue = (input.value || '').trim();
		
		if (!inputValue) {
			// Get default date based on selected period or use current date
			const defaultDate = new Date();
			if (fieldName === 'startDate') {
				this.customerAccountStatementForm.patchValue({ startDate: defaultDate }, { emitEvent: true });
			} else if (fieldName === 'endDate') {
				this.customerAccountStatementForm.patchValue({ endDate: defaultDate }, { emitEvent: true });
			}
			return;
		}

		// Force format on blur to ensure proper format
		const formatted = this.formatDateInputForModal(inputValue, true);
		input.value = formatted;
		
		// Parse and auto-correct
		let parsedDate = this.parseDateStringForModal(formatted);
		
		// If parsing failed, try to fix common issues
		if (!parsedDate && formatted.length > 0) {
			// Try with current year if year is missing
			const parts = formatted.split('/');
			if (parts.length === 2) {
				const withYear = parts[0] + '/' + parts[1] + '/' + new Date().getFullYear();
				parsedDate = this.parseDateStringForModal(withYear);
			}
		}
		
		if (parsedDate) {
			// Validate date range before updating
			const startDateValue = this.customerAccountStatementForm?.get('startDate')?.value;
			const endDateValue = this.customerAccountStatementForm?.get('endDate')?.value;
			
			let hasInvalidRange = false;
			
			// Check if the new date would create an invalid range
			if (fieldName === 'startDate') {
				if (endDateValue instanceof Date && parsedDate > endDateValue) {
					hasInvalidRange = true;
					// Start date cannot be after end date - set error message
					if (this.curentLang === 'ar') {
						this.modalDateRangeError = 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية';
					} else if (this.curentLang === 'he') {
						this.modalDateRangeError = 'תאריך התחלה לא יכול להיות אחרי תאריך סיום';
					} else {
						this.modalDateRangeError = 'Start date cannot be after end date';
					}
					} else {
					// Clear error if valid
					this.modalDateRangeError = '';
				}
			} else if (fieldName === 'endDate') {
				if (startDateValue instanceof Date && parsedDate < startDateValue) {
					hasInvalidRange = true;
					// End date cannot be before start date - set error message
					if (this.curentLang === 'ar') {
						this.modalDateRangeError = 'تاريخ النهاية لا يمكن أن يكون قبل تاريخ البداية';
					} else if (this.curentLang === 'he') {
						this.modalDateRangeError = 'תאריך סיום לא יכול להיות לפני תאריך התחלה';
					} else {
						this.modalDateRangeError = 'End date cannot be before start date';
					}
					} else {
					// Clear error if valid
					this.modalDateRangeError = '';
				}
			}
			
			// Update the form with Date object (even if invalid, so user can see the error)
			if (fieldName === 'startDate') {
				const formattedDate = this.formatDate(parsedDate);
				this.fromDate = formattedDate;
				this.customerAccountStatementForm.patchValue({ startDate: parsedDate }, { emitEvent: true });
			} else if (fieldName === 'endDate') {
				const formattedDate = this.formatDate(parsedDate);
				this.toDate = formattedDate;
				this.customerAccountStatementForm.patchValue({ endDate: parsedDate }, { emitEvent: true });
			}
			
			// Update input with correctly formatted date
			const day = String(parsedDate.getDate()).padStart(2, '0');
			const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
			const year = parsedDate.getFullYear();
			input.value = `${day}/${month}/${year}`;
			
			// Validate date range after updating (this will ensure error is set if still invalid)
			this.validateModalDateRange();
			
			this.cdRef.detectChanges();
		} else {
			// Invalid date - use current date as default
			const defaultDate = new Date();
			const day = String(defaultDate.getDate()).padStart(2, '0');
			const month = String(defaultDate.getMonth() + 1).padStart(2, '0');
			const year = defaultDate.getFullYear();
			input.value = `${day}/${month}/${year}`;
			
			if (fieldName === 'startDate') {
				this.customerAccountStatementForm.patchValue({ startDate: defaultDate }, { emitEvent: true });
			} else if (fieldName === 'endDate') {
				this.customerAccountStatementForm.patchValue({ endDate: defaultDate }, { emitEvent: true });
			}
			this.cdRef.detectChanges();
		}
	}

	
	/**
	 * @description Confirms and triggers the generation of a sales report.
	 * Retrieves values from `salesReportForm` and calls `getReportFilters`.
	 */
	confirmAction() {
		const { startDate, endDate, companyId, selectedPeriod } = this.salesReportForm.value;

		if (!startDate || !endDate || !companyId || !selectedPeriod) {
			console.error("All fields (startDate, endDate, companyId, selectedPeriod) must be provided.");
			return;
		}

		// Handle both Date objects and string dates
		let formattedStartDate: string;
		let formattedEndDate: string;

		if (startDate instanceof Date) {
			// If it's a Date object, format it directly
			formattedStartDate = this.formatDateForAPI(startDate);
		} else {
			// If it's a string, parse it
			const startDateParts = startDate.split('/');
			formattedStartDate = `${startDateParts[2]}-${startDateParts[1]}-${startDateParts[0]}`;
		}

		if (endDate instanceof Date) {
			// If it's a Date object, format it directly
			formattedEndDate = this.formatDateForAPI(endDate);
		} else {
			// If it's a string, parse it
			const endDateParts = endDate.split('/');
			formattedEndDate = `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`;
		}
		
		// Pass current language to ensure report is generated in the correct language
		this.getReportFilters(companyId, formattedStartDate, formattedEndDate, getDefaultReportLanguage());
	}

	/**
	 * @description Fetches and downloads a financial report (PDF) based on the provided filters.
	 * @param {any} [selectedCompany] - The ID of the selected company.
	 * @param {string} [fromDate] - The start date for the report (yyyy-MM-dd).
	 * @param {string} [toDate] - The end date for the report (yyyy-MM-dd).
	 * @param {any} [lang] - The language for the report.
	 */
	getReportFilters(selectedCompany?: any, fromDate?: string, toDate?: string, lang?: any) {
		this.spinner.show();
		this.service.getFinanicalReport(selectedCompany, fromDate, toDate, lang).subscribe({
			next: (pdfBlob) => {
				
				const blob = new Blob([pdfBlob], { type: 'application/pdf' });
				const downloadUrl = window.URL.createObjectURL(blob);

				const a = document.createElement('a');
				a.href = downloadUrl;
				a.download = `Income_Report_${selectedCompany}_${fromDate}_${toDate}.pdf`;
				document.body.appendChild(a);
				a.click();
				
				document.body.removeChild(a);
				window.URL.revokeObjectURL(downloadUrl);
				this.spinner.hide();
			},
			error: () => {
				this.spinner.hide();
			}
		});
	}

	
	/**
	 * @description Fetches all company information with pagination.
	 * Populates `this.companyData`.
	 * @param {number} [limit] - The number of records to fetch.
	 * @param {number} [offset] - The offset for fetching records.
	 */
	getAllCompaniesInfo(limit?: number, offset?: number) {
		limit = limit || this.limit;
		offset = offset || (this.currentPage - 1) * this.limit;
		this.spinner.show();
		this.service.getAllCompaniesInfo(limit, offset).subscribe({
			next: res => {
				this.companyData = [
					...res.data.map((company) => {
						const company_name_ar = company.company_name_ar?.trim() || '';
						const company_name_en = company.company_name_en?.trim() || '';
						const company_name_he = company.company_name_he?.trim() || '';
						return {
							...company,
							company_name_ar,
							company_name_en,
							company_name_he,
							company_display_label: company_name_he || company_name_en || company_name_ar || '',
						};
					}),
				];
				this.total = res.total;
				this.spinner.hide();

				const companyDefaultId = localStorage.getItem('companyDefault');
				if (companyDefaultId) {
					const foundCompany = this.companyData.find(company => company.company_id == companyDefaultId);
					if (foundCompany) {
						// Keep ngModel as number to match optionValue
						this.selectedCompany = Number(foundCompany.company_id);
						// Update allowed invoice types for the default company
						this.updateAllowedInvoiceTypes(Number(companyDefaultId));
					} else {
						this.selectedCompany = null;
						this.allowedInvoiceTypes = [];
					}
				} else {
					this.selectedCompany = null;
					this.allowedInvoiceTypes = [];
				}
				this.getAllCustomersForAccountStatement({ skipSpinner: true });
			},
			error: () => {
				this.spinner.hide();
			}
		});
	}

	
	/**
	 * @description Placeholder filter function for company selection.
	 * @param {any} event - The event object, expected to have `company_id`.
	 */
	filter2(event: any) {
		this.selectedCompany = event.company_id;
		this.onHeaderCompanyChanged(event.company_id);
	}

	/**
	 * @description Shows the report options confirmation dialog.
	 * Updates body scroll to prevent background scrolling.
	 */
	showReportOptions() {
		this.isConfirmDialogVisible = true;
		this.updateBodyScroll(); 
	}

	/**
	 * @description Closes any open report modals (Sales Report, Customer Account Statement)
	 * and returns to the main reports selection/view.
	 * Updates body scroll.
	 */
	closeAndReturnToReports() {
		this.isSalesReportModalVisible = false;
		this.isCustomerAccountStatementModalVisible = false;
		this.isConfirmDialogVisible = true;
		this.updateBodyScroll();
	}

	/**
	 * @description Triggers the generation and download of a Customer Account Statement PDF.
	 * Retrieves values from `customerAccountStatementForm`.
	 */
	CustomerAccountStatementAction() {
		// Prevent multiple simultaneous calls
		if (this.isPreparingPdf) {
			return;
		}
		
		// Validate form first
		if (!this.customerAccountStatementForm.valid) {
			console.error("Form is invalid:", this.customerAccountStatementForm.errors);
			Swal.fire({ 
				icon: 'warning', 
				title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة' : 
				       (this.curentLang === 'he' ? 'אנא מלא את כל השדות הנדרשים' : 'Please fill all required fields'),
				timer: 3000
			});
			return;
		}
		
		// Validate date range before proceeding
		if (!this.validateModalDateRange()) {
			// Error message is already set in validateModalDateRange()
			this.isPreparingPdf = false;
			return;
		}
		
		this.isPreparingPdf = true;
		const { startDate, endDate, selectedCustomer, selectedPeriod, accountType } = this.customerAccountStatementForm.value;

		// Helper function to convert date to YYYY-MM-DD format
		const convertToYYYYMMDD = (date: any): string | null => {
			if (!date) return null;
			
			// If it's already a Date object
			if (date instanceof Date) {
				if (isNaN(date.getTime())) return null;
				// Use datepipe to format as YYYY-MM-DD
				return this.datepipe.transform(date, 'yyyy-MM-dd') || null;
			}
			
			// If it's a string
			if (typeof date === 'string') {
				// Check if it's already in YYYY-MM-DD format
				if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
					return date;
				}
				
				// Try to parse dd/mm/yy or dd/mm/yyyy format
				const parts = date.split('/');
				if (parts.length === 3) {
					const day = parts[0].padStart(2, '0');
					const month = parts[1].padStart(2, '0');
					let year = parts[2];
					
					// Handle 2-digit years
					if (year.length === 2) {
						year = '20' + year;
					}
					
					// Validate and return
					if (day && month && year) {
						return `${year}-${month}-${day}`;
					}
				}
				
				// Try to parse as ISO string or other format
				const parsed = new Date(date);
				if (!isNaN(parsed.getTime())) {
					return this.datepipe.transform(parsed, 'yyyy-MM-dd') || null;
				}
			}
			
			return null;
		};

		// Convert dates to YYYY-MM-DD format
		const formattedStartDate = convertToYYYYMMDD(startDate);
		const formattedEndDate = convertToYYYYMMDD(endDate);
		
		// Validate converted dates are in correct order
		if (formattedStartDate && formattedEndDate) {
			if (formattedStartDate > formattedEndDate) {
				// Set error message
				if (this.curentLang === 'ar') {
					this.modalDateRangeError = 'تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية';
				} else if (this.curentLang === 'he') {
					this.modalDateRangeError = 'תאריך התחלה לא יכול להיות אחרי תאריך סיום';
				} else {
					this.modalDateRangeError = 'Start date cannot be after end date';
				}
				console.error('[CustomerAccountStatementAction] VALIDATION FAILED - Start date is after end date!');
				this.isPreparingPdf = false;
				Swal.fire({ 
					icon: 'error', 
					title: this.modalDateRangeError,
					text: this.curentLang === 'ar' ? 'يرجى تصحيح التواريخ قبل المتابعة' : 
					      (this.curentLang === 'he' ? 'אנא תקן את התאריכים לפני המשך' : 'Please correct the dates before proceeding'),
					timer: 4000
				});
				this.cdRef.detectChanges();
				return;
			}
		}

		if (!formattedStartDate) {
			console.error("Invalid startDate:", startDate);
			this.isPreparingPdf = false;
			Swal.fire({ 
				icon: 'error', 
				title: this.curentLang === 'ar' ? 'تاريخ البداية غير صحيح' : 
				       (this.curentLang === 'he' ? 'תאריך התחלה לא תקין' : 'Invalid start date'),
				timer: 3000
			});
			return;
		}

		if (!formattedEndDate) {
			console.error("Invalid endDate:", endDate);
			this.isPreparingPdf = false;
			Swal.fire({ 
				icon: 'error', 
				title: this.curentLang === 'ar' ? 'تاريخ النهاية غير صحيح' : 
				       (this.curentLang === 'he' ? 'תאריך סיום לא תקין' : 'Invalid end date'),
				timer: 3000
			});
			return;
		}

		if (!formattedStartDate || !formattedEndDate || !selectedCustomer || !selectedPeriod || accountType === null || accountType === undefined) {
			console.error("All fields (startDate, endDate, selectedCustomer, selectedPeriod, accountType) must be provided.");
			this.isPreparingPdf = false;
			Swal.fire({ 
				icon: 'warning', 
				title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة' : 
				       (this.curentLang === 'he' ? 'אנא מלא את כל השדות הנדרשים' : 'Please fill all required fields'),
				timer: 3000
			});
			return;
		}

		// Get companyId from localStorage or selectedCompany
		const companyId = this.selectedCompany || this.CompanyId || JSON.parse(localStorage.getItem('companyDefault') || 'null');

		// Debug logging
		// Pass current language, companyId, and claim (accountType) to ensure report is generated correctly
		this.service.downloadAccountStatement(selectedCustomer, {
			startDate: formattedStartDate,
			endDate: formattedEndDate,
			period: selectedPeriod,
			lang: getDefaultReportLanguage(),
			companyId: companyId,  // Add companyId for the new endpoint
			claim: accountType  // false = tax invoice, true = financial claim
		}).subscribe({
			next: (blob: Blob) => {
				if (blob && blob.size > 0) {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'AccountStatement.pdf';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				} else {
					console.error('Received empty blob');
					Swal.fire({ 
						icon: 'error', 
						title: this.translate.instant('merchant-info.errors.serverError'),
						text: this.curentLang === 'ar' ? 'الملف المستلم فارغ' : (this.curentLang === 'he' ? 'הקובץ שהתקבל ריק' : 'Received file is empty')
					});
				}
				this.spinner.hide();
				this.isPreparingPdf = false;
			},
			error: (err) => {
				console.error('API Error Details:', {
					error: err,
					status: err?.status,
					statusText: err?.statusText,
					errorBody: err?.error,
					url: err?.url,
					message: err?.message
				});
				this.spinner.hide();
				this.isPreparingPdf = false;
				
				// Get error message from API response if available
				let errorMessage = this.translate.instant('merchant-info.errors.serverError');
				if (err?.error) {
					if (err.error.messageAr) {
						errorMessage = err.error.messageAr;
					} else if (err.error.messageEn) {
						errorMessage = err.error.messageEn;
					} else if (err.error.messageHe) {
						errorMessage = err.error.messageHe;
					} else if (err.error.message) {
						errorMessage = err.error.message;
					} else if (typeof err.error === 'string') {
						errorMessage = err.error;
					}
				} else if (err?.message) {
					errorMessage = err.message;
				}
				
				// Show more detailed error in development
				const errorText = err?.status ? 
					`${errorMessage} (${err.status}${err.statusText ? ': ' + err.statusText : ''})` : 
					errorMessage;
				
				Swal.fire({ 
					icon: 'error', 
					title: errorText,
					timer: 5000,
					timerProgressBar: true
				});
			}
		});
	}

	/**
	 * @description Converts a date string or Date object to 'yyyy-MM-dd' format for backend API calls.
	 * @param {string | Date} date - The date to convert.
	 * @returns {string} The formatted date string.
	 */
	convertToBackendDateFormat(date: string | Date): string {
		return this.datepipe.transform(date, 'yyyy-MM-dd') || '';
	}

	
	/**
	 * @description Handles the change event when a customer is selected from a dropdown.
	 * Updates `this.selectedCustomer`.
	 * @param {any} customerId - The event object from the dropdown, expected to have `user_id`.
	 */
	onCustomerChange(event: { value?: unknown }): void {
		const id = event?.value;
		if (id !== null && id !== undefined && id !== '') {
			this.selectedCustomer = Number(id);
		}
	}

	/**
	 * @description Updates the body class to enable/disable scrolling based on dialog visibility.
	 * Prevents background scroll when modals are open.
	 * @private
	 */
	private updateBodyScroll(): void {
		const isAnyModalOpen = this.isCustomerAccountStatementModalVisible ||
							   this.isSalesReportModalVisible ||
							   this.isConfirmDialogVisible;

		if (isAnyModalOpen) {
			this.renderer.addClass(this.document.body, 'body-no-scroll');
		} else {
			this.renderer.removeClass(this.document.body, 'body-no-scroll');
		}
	}

	/**
	 * @description Opens the Sales Report modal.
	 * Closes the confirmation dialog if it was open.
	 */
	openSalesReportModal() {
		this.isSalesReportModalVisible = true;
		this.isConfirmDialogVisible = false; 
		this.updateBodyScroll();
	}

	/**
	 * @description Opens the Customer Account Statement modal.
	 * Closes the confirmation dialog if it was open.
	 */
	openCustomerAccountStatementModal() {
		this.isCustomerAccountStatementModalVisible = true;
		this.isConfirmDialogVisible = false;
		this.getAllCustomersForAccountStatement({ skipSpinner: true });
		// Update account type default when opening modal
		const defaultAccountType = this.getDefaultAccountType();
		this.customerAccountStatementForm.patchValue({ accountType: defaultAccountType });
		// Clear any previous validation errors
		this.modalDateRangeError = '';
		// Validate date range when modal opens
		setTimeout(() => {
			this.validateModalDateRange();
		}, 100);
		this.updateBodyScroll();
	}

	/**
	 * @description Gets the default account type based on the selected company's type.
	 * Returns false for tax invoice (مصلحة تجارية or مشتغل), true for financial claim (جمعية or معفي).
	 * @returns {boolean} - false for tax invoice, true for financial claim
	 */
	getDefaultAccountType(): boolean {
		const companyId = this.selectedCompany || this.CompanyId || JSON.parse(localStorage.getItem('companyDefault') || 'null');
		if (!companyId || !this.companyData || this.companyData.length === 0) {
			// Default to tax invoice if no company data
			return false;
		}

		const selectedCompany = this.companyData.find((company: any) => company.company_id === companyId);
		if (!selectedCompany || !selectedCompany.companyType) {
			// Default to tax invoice if no company type data
			return false;
		}

		const typeNameAr = selectedCompany.companyType.type_name_ar || '';
		
		// Check if company type is "جمعية" (association) or "معفي" (exempt) -> financial claim (true)
		// Otherwise (مصلحة تجارية, مشتغل, etc.) -> tax invoice (false)
		if (typeNameAr.includes('جمعية') || typeNameAr.includes('معفي')) {
			return true; // Financial claim
		}
		
		return false; // Tax invoice (default for مصلحة تجارية, مشتغل, etc.)
	}

	/**
	 * @description Closes the confirmation dialog for report selection.
	 * Updates body scroll.
	 */
	closeConfirmDialog() {
		this.isConfirmDialogVisible = false;
		this.isSalesReportModalVisible = false;
		this.isCustomerAccountStatementModalVisible = false;
		this.updateBodyScroll();

		const isMerchantHomeUser = this.user_type === 100 || this.user_type === 101;
		if (isMerchantHomeUser) {
			this.router.navigate(['/dashboard/dashboard'], { replaceUrl: true });
		} else {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: { openReports: null },
				queryParamsHandling: 'merge',
				replaceUrl: true,
			});
		}
	}

	/**
	 * @description Opens the Customer Balances Report page.
	 * Closes the confirmation dialog and navigates to the customer balances route.
	 */
	openCustomerBalancesReport() {
		this.isConfirmDialogVisible = false;
		this.updateBodyScroll();
		this.router.navigate(['/dashboard/customer-balances']);
	}

	/**
	 * @description Opens the Profit & Loss (Gain/Loss) Report page.
	 * Closes the confirmation dialog and navigates to the reports-gain-loss route.
	 */
	openGainLossReport() {
		this.isConfirmDialogVisible = false;
		this.updateBodyScroll();
		this.router.navigate(['/dashboard/reports-gain-loss']);
	}

	openChecksReport() {
		this.isConfirmDialogVisible = false;
		this.updateBodyScroll();
		this.router.navigate(['/dashboard/checks-report']);
	}

	/**
	 * @description Updates the `isMobile` flag based on the current window width.
	 * @private
	 */
	private updateIsMobile() {
		this.isMobile = window.innerWidth <= 768;
	}
}
